import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ArchiveNavDropdown.css';

const ITEMS = [
  { key: 'insight', to: '/blog', labelKey: 'home.insightTitle', internal: true },
  { key: 'dev-log', to: '/dev-blog', labelKey: 'blog.filterDevLog', internal: true },
];

function ArchiveNavDropdown({ onNavigate }) {
  const { t } = useTranslation();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const isInsight =
    location.pathname === '/blog' || location.pathname.startsWith('/blog/');
  const isDevLog =
    location.pathname === '/dev-blog' || location.pathname.startsWith('/dev-blog/');
  const isArchiveActive = isInsight || isDevLog;

  useEffect(() => {
    const onPointerDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handlePick = () => {
    setOpen(false);
    onNavigate?.();
  };

  const archiveLabel = t('nav.devBlog');

  return (
    <li className="nav-archive-item" ref={ref}>
      <div className={`nav-archive ${open ? 'is-open' : ''} ${isArchiveActive ? 'is-active' : ''}`}>
        <button
          type="button"
          className="nav-archive-btn"
          aria-expanded={open}
          aria-haspopup="true"
          onClick={(e) => {
            e.stopPropagation();
            setOpen((v) => !v);
          }}
        >
          <span className="nav-archive-label" data-text={archiveLabel}>
            {archiveLabel}
          </span>
          <span className="nav-archive-chevron" aria-hidden="true" />
        </button>

        <div
          className={`nav-archive-menu ${open ? 'is-visible' : ''}`}
          role="menu"
          aria-hidden={!open}
        >
          {ITEMS.map((item) => (
            <Link
              key={item.key}
              to={item.to}
              role="menuitem"
              tabIndex={open ? 0 : -1}
              className={
                (item.key === 'insight' && isInsight) || (item.key === 'dev-log' && isDevLog)
                  ? 'is-active'
                  : ''
              }
              onClick={handlePick}
            >
              {t(item.labelKey)}
            </Link>
          ))}
        </div>
      </div>
    </li>
  );
}

export default ArchiveNavDropdown;
